import * as MobileDragDrop from 'mobile-drag-drop';
import { scrollBehaviourDragImageTranslateOverride } from 'mobile-drag-drop/scroll-behaviour';
import 'mobile-drag-drop/default.css';
import 'core-js/es/string/replace-all';
import 'core-js/es/array/flat';
import 'core-js/es/object/from-entries';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';

const usePolyfill = MobileDragDrop.polyfill({ 
  dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride
});
// MobileDragDropはiPadOSを検知できないため
const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
if (isIPadOS) {
  MobileDragDrop.polyfill({
    dragImageTranslateOverride: scrollBehaviourDragImageTranslateOverride,
    forceApply: true,
  });
}
if (usePolyfill || isIPadOS) {
  document.addEventListener('dragenter', function(event) {
    event.preventDefault();
  });

  window.addEventListener('touchmove', function (){}, { passive: false });
}